import Module from "./Module";
import InvoiceList from "./views/InvoiceList.vue";
import InvoiceAdd from "./views/InvoiceAdd.vue";
import InvoiceCreate from "./views/InvoiceCreate.vue";
import InvoiceDetail from "./views/InvoiceDetail.vue";
import InvoicePembayaran from "./views/InvoicePembayaran.vue";
import DetailTagihan from "./views/DetailTagihan.vue";
import Penjadwalan from "./views/PenjadwalanOtomatis.vue"; 
import PenjadwalanCreate from "./views/PenjadwalanOtomatisCreate.vue"; 
import PenjadwalanRiwayat from "./views/PenjadwalanOtomatisRiwayat.vue"; 
import InvoiceDone from "./views/InvoiceDone.vue";
import helpers from "../../helpers/helpers";

const requireAuth = { requireAuth: true };

const moduleRoute = {
    path: "/invoice",
    component: Module,
    children: [
        {
            path: "",
            component: Module,
            children: [
                {
                    path: "",
                    name: "invoice.list",
                    component: InvoiceList,
                    meta: {
                        ...requireAuth,
                        accessKey: 'list.read',
                    },
                },
                {
                    path: "pembatalan-invoice/:invoiceId",
                    name: "invoice.list.pembatalan_invoice",
                    components: {
                        default: InvoiceList,
                        dialog: () => {
                            return import("./components/modals/PembatalanInvoice.vue");
                        },
                    },
                    meta: {
                        ...requireAuth,
                        accessKey: 'list.delete',
                    },
                },
                {
                    path: "hapus-invoice/:invoiceId",
                    name: "invoice.list.hapus_invoice",
                    components: {
                        default: InvoiceList,
                        dialog: () => {
                            return import("./components/modals/ConfirmDelete.vue");
                        },
                    },
                    meta: {
                        ...requireAuth,
                        accessKey: 'list.delete',
                    },
                },
                {
                    path: "batal-invoice/:invoiceId",
                    name: "invoice.list.batal_invoice",
                    components: {
                        default: InvoiceList,
                        dialog: () => {
                            return import("./components/modals/ConfirmDelete.vue");
                        },
                    },
                },
                {
                    path: "batal-hapus/:invoiceId",
                    name: "invoice.list.batal_hapus",
                    components: {
                        default: InvoiceList,
                        dialog: () => {
                            return import("./components/modals/PembatalanInvoice.vue");
                        },
                    },
                },
                // {
                //     path: "export-invoice/:invoiceId",
                //     name: "invoice.list.export",
                //     components: {
                //         default: InvoiceList,
                //         dialog: () => {
                //             return import("./components/modals/ExportInvoice.vue");
                //         },
                //     },
                // },
                // {
                //     path: "export-invoice/:invoiceId",
                //     name: "invoice.success.export",
                //     components: {
                //         default: InvoiceDone,
                //         dialog: () => {
                //             return import("./components/modals/ExportInvoice.vue");
                //         },
                //     },
                // },
                {
                    path: "send-invoice/:invoiceId",
                    name: "invoice.send.wa",
                    components: {
                        default: InvoiceList,
                        dialog: () => {
                            return import("./components/modals/ConfirmSendInvoice.vue");
                        },
                    },
                },
                {
                    path: "send-invoice/:invoiceId",
                    name: "invoice.success.send.wa",
                    components: {
                        default: InvoiceDone,
                        dialog: () => {
                            return import("./components/modals/ConfirmSendInvoice.vue");
                        },
                    },
                }
            ],
        },
        
        {
            path: "penjadwalan",
            component: Module,
            children: [
                {
                    path: "",
                    name: "invoicePenjadwalan",
                    component: Penjadwalan,
                    meta: {
                        ...requireAuth,
                        accessKey: 'schedule.read',
                    },
                },
                {
                    path: "create",
                    name: "invoicePenjadwalan.create",
                    component: PenjadwalanCreate,
                    meta: {
                        ...requireAuth,
                        accessKey: 'schedule.create',
                    },
                },
                {
                    path: ":id",
                    name: "invoicePenjadwalan.edit",
                    component: PenjadwalanCreate,
                    meta: {
                        ...requireAuth,
                        accessKey: 'schedule.update',
                    },
                    props: true,
                },
                {
                    path: "riwayat_dijalankan/:idcustomer",
                    name: "invoicePenjadwalan.riwayat",
                    component: PenjadwalanRiwayat,
                    meta: {
                        ...requireAuth,
                        accessKey: 'schedule.read',
                    },
                    props: true,
                },
            ]
        },
        {
            path: "tambah",
            component: Module,
            children: [
                {
                    path: "",
                    name: "invoice.add",
                    component: InvoiceAdd,
                    meta: {
                        ...requireAuth,
                        accessKey: 'list.create',
                    },
                },
                {
                    path: "confirm",
                    name: "invoice.add.confirm",
                    components: {
                        default: InvoiceAdd,
                        dialog: () => {
                            return import("./components/modals/ConfirmAddInvoice.vue");
                        },
                    },
                    meta: {
                        ...requireAuth,
                        accessKey: 'list.create',
                    },
                },
            ],
        },
        {
            path: "create",
            component: Module,
            children: [
                {
                    path: "",
                    name: "invoice.create",
                    component: InvoiceCreate,
                    meta: {
                        ...requireAuth,
                        accessKey: 'list.create',
                    },
                },
                {
                    path: "tambah-pengingat",
                    name: "invoice.create.tambah_pengingat",
                    components: {
                        default: InvoiceCreate,
                        dialog: () => {
                            return import("./components/modals/UpdatePengingat.vue");
                        },
                    },
                    meta: requireAuth,
                },
                {
                    path: "update-pengingat/:id",
                    name: "invoice.create.update_pengingat",
                    components: {
                        default: InvoiceCreate,
                        dialog: () => {
                            return import("./components/modals/UpdatePengingat.vue");
                        },
                    },
                    meta: requireAuth,
                },
                {
                    path: "detail-biaya",
                    name: "invoice.create.detail_biaya",
                    components: {
                        default: InvoiceCreate,
                        dialog: () => {
                            return import("./components/modals/DetailBiaya.vue");
                        },
                    },
                    meta: requireAuth,
                },
            ],
        },
        {
            path: "detail/:invoiceId",
            component: Module,
            children: [
                {
                    path: "",
                    name: "invoice.detail",
                    component: InvoiceDetail,
                    meta: {
                        ...requireAuth,
                        accessKey: 'list.read',
                    },
                },
                {
                    path: "pembayaran",
                    name: "invoice.detail.pembayaran",
                    component: InvoicePembayaran,
                    meta: {
                        ...requireAuth,
                        accessKey: 'list.payoff',
                    },
                },
                {
                    path: "donesuccess",
                    name: "invoice.detail.donesuccess",
                    component: InvoiceDone,
                    meta: requireAuth,
                },
                {
                    path: "detail-tagihan",
                    name: "invoice.detail.detail_tagihan",
                    component: DetailTagihan,
                    meta: {
                        ...requireAuth,
                        accessKey: 'list.read',
                    },
                },
                {
                    path: "tolak-permintaan",
                    name: "invoice.detail.tolak_permintaan",
                    components: {
                        default: InvoiceDetail,
                        dialog: () => {
                            return import("./components/modals/TolakPermintaan.vue");
                        },
                    },
                    meta: {
                        ...requireAuth,
                        accessKey: 'list.update',
                    },
                },
                {
                    path: "terima-permintaan",
                    name: "invoice.detail.terima_permintaan",
                    components: {
                        default: InvoiceDetail,
                        dialog: () => {
                            return import("./components/modals/TerimaPermintaan.vue");
                        },
                    },
                    meta: {
                        ...requireAuth,
                        accessKey: 'list.update',
                    },
                },
                {
                    path: "detail-info",
                    name: "invoice.detail.detail_info",
                    components: {
                        default: InvoiceDetail,
                        dialog: () => {
                            return import("./components/modals/DetailInfo.vue");
                        },
                    },
                    meta: {
                        ...requireAuth,
                        accessKey: 'list.read',
                    },
                },
            ],
        },
    ],
};

export default (router) => {
    router.addRoutes([moduleRoute]);
};
